// This service module capture any user click in the window and inform listeners
import * as React from "react";

import {FComponent} from "./f-component";

export const AnyAction = ({disabled=false, action, capture=false, next=undefined}) => React.createElement(AnyAction1, {disabled, action, capture, next});

interface P {
    disabled: boolean;
    capture: boolean;
    action: (e) => void;
    next: () => any;
}
interface S {
}
class AnyAction1 extends FComponent<P,S> {
    constructor(props, context) {
        super(props, context);

        if (typeof window !== "undefined") {
            this.onMount(() => {
                setTimeout(
                    () => {
                        const listener = (e) => {
                            if (!this.props.disabled) {
                                this.props.action(e);
                            }
                        };
                        window.addEventListener("click", listener, {capture: this.props.capture});

                        this.onUnmount(() => {
                            window.removeEventListener("click", listener, {capture: this.props.capture});
                        });
                    },
                );
            });
        }
    }

    render() {
        const {next} = this.props;
        return next?.() ?? null;
    }
}